const env = process.env.REACT_APP_ENV ;
console.log("env",env)

let redirectUri = 'http://localhost:3000';
let oAuth2Url = 'https://dev.sso.dtst.k8s';

  if (env === 'dev') {
    redirectUri = 'https://dev-glasshouse-masraf.dakika.com.tr';
    oAuth2Url = 'https://dev.sso.dtst.k8s';
  } else if (env === 'test') {
  redirectUri = 'https://testmasraf.dakika.com.tr';
  oAuth2Url = 'https://test-login.dakika.com.tr';
  } else if (env === 'production') {
  redirectUri = 'https://masraf.dakika.com.tr';
  oAuth2Url = 'https://login.dakika.com.tr';
}

export default{
  url: oAuth2Url,
  authorizationPath: '/oauth/authorize',
  checkUserPath: '/oauth/user',
  clientId: 'masraf-fe',
  redirectUri,
  responseType: 'code',
  scope: 'uid',
};
